import React, { useState } from 'react';
import UserFormModal from './UserFormModal';
//import { formatPayload } from '../../../../common/PhoneInput';

const EditUserButton = ({ columnData, onUpdateUser }) => {
  const [modalVisible, setModalVisible] = useState(false);
  const showModal = () => {
    setModalVisible(true);
  };
  const hideModal = () => {
    setModalVisible(false);
  };
  const onSubmit = async (data) => {
    const payloadObj = {
      id: columnData.id,
      payload: { user: data },
    };
    await onUpdateUser(payloadObj);
    hideModal();
  };
  return (
    <>
      <UserFormModal
        data={columnData}
        onSubmit={onSubmit}
        onCancel={hideModal}
        visible={modalVisible}
        title={`Edit Company Staff - ${columnData.name}`}
        submitText="Save"
      />
      <div onClick={showModal}> Edit User </div>
    </>
  );
};
export default EditUserButton;
